import React, { useContext } from "react";
import * as S from "./post-previews.styles";
import { Link } from "gatsby";
import { getImage } from "gatsby-plugin-image";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons';
import { ThemeContext } from "styled-components";

const PostPreview = ({ post }) => {
  const { theme } = useContext(ThemeContext);

  const coverImage = getImage(post.frontmatter.hero_image);
  const postLink = `/blog/${post.slug}`;

  return (
    <S.PostPreviewItem>
      <S.PostPreviewContainer>

        <Link to={postLink}>
          <S.PostPreviewCoverImage
            image={coverImage}
            alt={post.frontmatter.hero_image_alt}
          />
        </Link>

        <S.PostPreviewContentContainer>
          
          <Link to={postLink}>
            <S.PostPreviewTitle>
              {post.frontmatter.title}
            </S.PostPreviewTitle>
          </Link>

          <S.PostPreviewDateContainer>
            <FontAwesomeIcon icon={faCalendarAlt} />
            <S.PostPreviewDatePosted>
              {post.frontmatter.date}
            </S.PostPreviewDatePosted>
          </S.PostPreviewDateContainer>
          
          <S.PostPreviewSubtitle>
            {post.frontmatter.subtitle}
            {post.excerpt}
          </S.PostPreviewSubtitle>

          <S.ReadMoreContainer>
            <S.ReadMoreLink to={postLink} theme={theme}>
              Read More
            </S.ReadMoreLink>
          </S.ReadMoreContainer>

        </S.PostPreviewContentContainer>

      </S.PostPreviewContainer>
    </S.PostPreviewItem>
  );
};

export default PostPreview;